import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getInvoices } from "../../../lib/getInvoices";
import AllInvoicesTable from "./AllInvoicesTable";

const AllInvoices = () => {
  debugger
  const [invoicesList, setInvoicesList] = useState([]);
  const navigate = useNavigate();

  // Memorizar el valor de `storage` para evitar múltiples lecturas del localStorage.
  const storage = useMemo(() => {
    return JSON.parse(window.localStorage.getItem("userDetails"));
  }, []);

  useEffect(() => {
    if (storage?.role === "superadmin") {
      debugger
      getInvoices().then((res) => {

        if (Array.isArray(res.data)) {
          debugger
          // Solo actualizamos el estado si los datos son distintos
          if (JSON.stringify(invoicesList) !== JSON.stringify(res.data)) {
            setInvoicesList(res.data);
          }
        } else {
          setInvoicesList([]); // Inicializa como array vacío si no es un array
        }
      });
    } else {
      navigate("/");
    }
    // Evitamos que `employeeList` sea una dependencia aquí para evitar el ciclo infinito
  }, [navigate, setInvoicesList]);

  return (
    <>
     <h2>Listado de Facturas</h2>
      <AllInvoicesTable
        data={invoicesList}
        setInvoicesList={setInvoicesList}
      />
    </>
  );
};

export default AllInvoices;
